const profile = {
  title: "Profil saya",
  premiumBtn: "Mulai berlangganan",
  orderInfoTitle: "Info izin akun.",
  tableProduct: "Produk",
  tableStatus: "Status",
  tablePermissionDate: "Tanggal izin",
  tableValidPeriod: "Waktu berlaku",
  validStauts: "Valid",
  expiredStauts: "Kedaluwarsa",
  noData: "Tidak ada data",
};

export default profile;
